import { createFileRoute } from '@tanstack/react-router';
import { PublicQuotePage } from '../../features/rates';

export const Route = createFileRoute('/_public/quote/$token')({
  component: function PublicQuoteRoute() {
    const { token } = Route.useParams();
    return <PublicQuotePage token={token} />;
  },
});
